export default function Modal({ children }: { children: JSX.Element }) {
  return (
    <div className="fixed top-0 left-0 w-screen h-screen flex justify-center items-center bg-background bg-opacity-60">
      <div className="bg-grayish rounded-xl p-4">{children}</div>
    </div>
  );
}
